import { render, staticRenderFns } from "./PostBody.vue?vue&type=template&id=691d3d7c&"
import script from "./PostBody.vue?vue&type=script&lang=js&"
export * from "./PostBody.vue?vue&type=script&lang=js&"
import style0 from "./PostBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports